import { api } from '../lib/api.js';

export interface Notification {
  id: string;
  type: string;
  title: string;
  message: string;
  link: string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  list: (unreadOnly = false) =>
    api
      .get<{ data: Notification[] }>('/notifications', {
        params: unreadOnly ? { unread: 'true' } : undefined,
      })
      .then((r) => r.data),
  unreadCount: () =>
    api.get<{ data: { count: number } }>('/notifications/unread-count').then((r) => r.data.count),
  markRead: (id: string) =>
    api.patch<{ data: { ok: true } }>(`/notifications/${id}/read`),
  markAllRead: () =>
    api.patch<{ data: { count: number } }>('/notifications/read-all'),
};
